import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["row"];

  toggle(event) {
    event.preventDefault();

    const row = event.currentTarget.closest("[data-note-id]");
    const isCollapsed = row.dataset.collapsed === "true";

    row.dataset.collapsed = isCollapsed ? "false" : "true";

    const icon = event.currentTarget.querySelector("i");

    icon.classList.toggle("bi-chevron-down", isCollapsed);
    icon.classList.toggle("bi-chevron-right", !isCollapsed);

    this.#updateVisibility();
  }

  #updateVisibility() {
    const collapsedIds = new Set(
      this.rowTargets
        .filter((row) => row.dataset.collapsed === "true")
        .map((row) => row.dataset.noteId)
    );

    this.rowTargets.forEach((row) => {
      const parentId = row.dataset.parentId;
      if (!parentId) return;

      let hidden = false;
      let currentParentId = parentId;
      while (currentParentId) {
        if (collapsedIds.has(currentParentId)) {
          hidden = true;
          break;
        }
        const parentRow = this.rowTargets.find(
          (r) => r.dataset.noteId === currentParentId
        );
        currentParentId = parentRow?.dataset.parentId;
      }

      row.classList.toggle("d-none", hidden);
    });
  }
}
